import { useState } from "react";
import QuestionBox from "../../ui/QuestionBox/QuestionBox";
import RadioButton from "../../ui/RadioButton/RadioButton";
import classes from "../Infrastructure/Infrastructure.module.css";
import CommonFooter from "../../CommonFooter/CommonFooter";
import { useAuth } from "../../../context/AuthContext";
import { useParams } from "react-router-dom";
import CommonButton from "../../ui/CommonButton/CommonButton";
import { useQuestionnaire } from "../../../hooks/useQuestionnaire";

const initialState = {
  hasColdChain: "",
  stockouts: "",
  storageConditions: "",
  supplyChainChallenges: "",
};

const LogisticsSupplyChain = () => {
  const {
    formData,
    handleChange,
    handleDone,
    editMode,
    setEditMode,
    isReadOnly,
    isFetching,
    loading,
    isOffline,
  } = useQuestionnaire("quality-management", initialState);

  const [currentSet, setCurrentSet] = useState(0);
  const { user } = useAuth();

  const { labId: paramLabId } = useParams();

  const userRole = user?.role;

  

  const handleNext = () => {
    if (currentSet < questionSets.length - 1) {
      setCurrentSet((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    if (currentSet > 0) {
      setCurrentSet((prev) => prev - 1);
    }
  };

  
  // -------------------------------------------------------
  // UI Question Sets
  // -------------------------------------------------------
  const questionSets = [
    {
      content: (
        <div className="d-flex flex-column gap-4">
          <QuestionBox
            number={1}
            question="Is there Quality Management System (QMS) in place or being put in place at the Laboratory?"
            disabled={isReadOnly}
          >
            <div className="d-flex gap-2 mb-4">
              <RadioButton
                label="Yes"
                name="hasQMS"
                checked={formData.hasQMS === "Yes"}
                onChange={() => handleChange("hasQMS", "Yes")}
                disabled={isReadOnly}
              />
              <RadioButton
                label="No"
                name="hasQMS"
                checked={formData.hasQMS === "No"}
                onChange={() => handleChange("hasQMS", "No")}
                disabled={isReadOnly}
              />
            </div>
          </QuestionBox>
          <QuestionBox
            number={2}
            question="Is there a Quality Officer at the Laboratory?"
            disabled={isReadOnly}
          >
            <div className="d-flex gap-2 mb-4">
              <RadioButton
                label="Yes"
                name="hasQualityOfficer"
                checked={formData.hasQualityOfficer === "Yes"}
                onChange={() => handleChange("hasQualityOfficer", "Yes")}
                disabled={isReadOnly}
              />
              <RadioButton
                label="No"
                name="hasQualityOfficer"
                checked={formData.hasQualityOfficer === "No"}
                onChange={() => handleChange("hasQualityOfficer", "No")}
                disabled={isReadOnly}
              />
            </div>
          </QuestionBox>
          <QuestionBox
            number={3}
            question="Name of the Quality Officer?"
            disabled={isReadOnly}
          >
            <div className="d-flex gap-2 mb-2">
              <div
                className={`${classes.customInput} d-flex align-items-center`}
              >
                <input
                  type="text"
                  placeholder="Enter name"
                  onChange={(e) =>
                    handleChange("qualityOfficerName", e.target.value)
                  }
                  value={formData.qualityOfficerName}
                  disabled={isReadOnly}
                />
              </div>
            </div>
          </QuestionBox>
          <QuestionBox
            number={4}
            question="Which tool or standard is being applied at the Laboratory?"
            disabled={isReadOnly}
          >
            <div className="d-flex gap-2 mb-2">
              <div
                className={`${classes.customInput} d-flex align-items-center`}
              >
                <input
                  type="text"
                  placeholder="Enter name"
                  onChange={(e) =>
                    handleChange("qmsToolOrStandard", e.target.value)
                  }
                  value={formData.qmsToolOrStandard}
                  disabled={isReadOnly}
                />
              </div>
            </div>
          </QuestionBox>
          <QuestionBox
            number={5}
            question="Is there internal Quality Controls in use at the Laboratory?"
            disabled={isReadOnly}
          >
            <div className="d-flex gap-2 mb-2">
              <RadioButton
                label="Yes"
                name="hasInternalQualityControls"
                checked={formData.hasInternalQualityControls === "Yes"}
                onChange={() =>
                  handleChange("hasInternalQualityControls", "Yes")
                }
                disabled={isReadOnly}
              />
              <RadioButton
                label="No"
                name="hasInternalQualityControls"
                checked={formData.hasInternalQualityControls === "No"}
                onChange={() =>
                  handleChange("hasInternalQualityControls", "No")
                }
                disabled={isReadOnly}
              />
            </div>
          </QuestionBox>
          <QuestionBox
            number={6}
            question="Is the laboratory enrolled in External Quality Assessment (EQA) programs?"
            singleInput
            answers={formData.eqaPrograms}
            onAnswersChange={(newAnswers) =>
              handleChange("eqaPrograms", newAnswers)
            }
            disabled={isReadOnly}
          />
        </div>
      ),
    },
  ];

  const { content } = questionSets[currentSet];

  if (isFetching) {
    return <div className={classes.loading}>Loading...</div>;
  }

  return (
    <div
      className={`${classes.wrapper} ${paramLabId ? classes.fromParams : ""} ${
        isReadOnly ? classes.readOnly : ""
      }`}
    >
      <div className="d-flex justify-content-between align-items-center">
        <h2>Logistics & Supply Chain</h2>

        {userRole === "LABORATORY" && !editMode && (
          <CommonButton
            className={classes.editButton}
            onClick={() => setEditMode(true)}
            title="Edit"
          />
        )}
      </div>

      {!editMode && userRole !== "MINISTRY" ? (
        <div className={classes.infoText}>
          ✅ Your Logistics & Supply Chain form has been submitted.
        </div>
      ) : (
        content
      )}

      {!isReadOnly && (
        <CommonFooter
          handlePrevious={handlePrevious}
          handleNext={handleNext}
          handleDone={handleDone}
          cancelText="Cancel"
          handleCancel={() => {
            setEditMode(false);
            setCurrentSet(0);
          }}
          questionSets={questionSets}
          currentSet={currentSet}
          loading={loading}
          doneText={
            loading ? "Submitting..." : isOffline ? "Save Offline" : "Submit"
          }
        />
      )}
    </div>
  );
};

export default LogisticsSupplyChain;
